<template>
    <div class="component-settings-interests">
        <div class="el-card__header text-left border" style="margin-left: 225px;" slot="header" v-if="$store.state.general.settingsMenuMode === 'vertical'">
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <div class="el-card__header text-left border" slot="header" v-else>
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never" style="min-height: 300px" v-loading="!loaded">
                        <el-alert
                            title="Store interests updated"
                            type="success"
                            show-icon
                            v-if="interestsUpdated">
                        </el-alert>
                        <el-tabs v-model="activeName" v-if="loaded">
                            <el-tab-pane label="Stores" name="Stores">
                                <div class="row">
                                    <div class="col-12">
                                        <avatar style="display: inline-block; margin-right: 10px;" :lighten="100" :username="$store.getters['general/getUsers'].find(x => x.user_id === user).first_name + ' ' + $store.getters['general/getUsers'].find(x => x.user_id === user).last_name" :size="35"></avatar>
                                        <el-select
                                            v-model="user"
                                            filterable
                                            collapse-tags
                                            placeholder="User select"
                                            @visible-change="userSelectChange($event)">
                                            <el-option
                                                v-for="user in $store.getters['general/getUsers']"
                                                :key="user.user_id"
                                                :label="user.first_name +' '+ user.last_name"
                                                :value="user.user_id">
                                            </el-option>
                                        </el-select>
                                        <el-input
                                            v-model="search"
                                            placeholder="Type to search"
                                            style="width: 200px; margin-left: 10px;"
                                        />
                                        <el-button class="fr" type="primary" plain @click="saveInterests">Save</el-button>
                                    </div>
                                </div>
                                <template>
                                    <el-table
                                        :data="tableData.filter(data => !search || String(data['Store']).includes(search))"
                                        style="width: 100%; margin: 20px 0px;"
                                        :default-sort = "{prop: 'Store', order: 'ascending'}">
                                        <el-table-column
                                            label="Store"
                                            prop="Store"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                {{$store.state.general.stores.find(x => x.store_id === scope.row.Store).store_name}}
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                            label="Active"
                                            prop="Active"
                                            sortable

                                        >
                                            <template slot-scope="scope">
                                                <el-checkbox :disabled="true" v-model="$store.state.general.allStores.find(x => x.store_id === scope.row.Store).active"></el-checkbox>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                            v-for="col in Object.values(this.$store.getters['budget/getLevels'])"
                                            :key="col"
                                            :prop="col"
                                            :label="col">
                                            <template slot-scope="scope">
                                                <el-checkbox v-model="scope.row[col]"></el-checkbox>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-tab-pane>
                            <el-tab-pane label="Alerts" name="Alerts" >
                                <div class="row">
                                    <div class="col-12">
                                        <avatar style="display: inline-block; margin-right: 10px;" :lighten="100" :username="$store.getters['general/getUsers'].find(x => x.user_id === user).first_name + ' ' + $store.getters['general/getUsers'].find(x => x.user_id === user).last_name" :size="35"></avatar>
                                        <el-select
                                            v-model="user"
                                            filterable
                                            collapse-tags
                                            placeholder="User select"
                                            @visible-change="userSelectChange($event)">
                                            <el-option
                                                v-for="user in $store.getters['general/getUsers']"
                                                :key="user.user_id"
                                                :label="user.first_name +' '+ user.last_name"
                                                :value="user.user_id">
                                            </el-option>
                                        </el-select>
                                        <el-button class="fr" type="primary" plain @click="saveMessages">Save</el-button>
                                    </div>
                                </div>
                                <div class="row mt-20">
                                    <div class="col-4">
                                        <h4>Budget alerts</h4>
                                        <el-table
                                            :data="alertsTableData['budget']"
                                            style="width: 100%; margin: 20px 0px;"
                                        >
                                            <el-table-column
                                                prop="type_name"
                                                label="Name"
                                            >
                                                <template slot-scope="scope">
                                                    {{scope.row.type_name | formatVariableName}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-for="col in alertTableHeaders['budget']"
                                                :key="col.prop"
                                                :prop="col.prop"
                                                :label="col.label">
                                                <template slot-scope="scope">
                                                    <el-checkbox :disabled="scope.row[col.prop+'_setting'] === false" v-model="scope.row[col.prop]"></el-checkbox>
                                                </template>
                                            </el-table-column>
                                            <el-table-column type="expand">
                                                <template slot-scope="props">
                                                    <div class="row" v-if="Object.keys(props.row.parameters).length === 0">
                                                        <div class="col-12">
                                                            <span>No parameters</span>
                                                        </div>
                                                    </div>
                                                    <div class="row center-align-vert mb-10" v-else v-for="(value,key) in props.row.parameters" :key=key>
                                                        <div class="col-4">
                                                            <span class="demo-input-label" style="width: 100px;">{{key | formatVariableName}}</span>
                                                        </div>
                                                        <div class="col-8">
                                                            <el-select
                                                                v-model="mutedStores.find(x => x.type_name === props.row.type_name).store_id"
                                                                filterable
                                                                :clearable=true
                                                                multiple
                                                                collapse-tags
                                                                class="ml-5-howrly"
                                                                style="min-width: 150px;"
                                                                placeholder="Exclude stores"
                                                                v-if="(key === 'stores_exclude' &&  mutedStores.find(x => x.type_name === props.row.type_name) !== undefined)"
                                                            >
                                                                <el-option
                                                                    v-for="item in $store.getters['general/getStores']"
                                                                    :key="item.store_id"
                                                                    :label="item.store_name"
                                                                    :value="item.store_id">
                                                                </el-option>
                                                            </el-select>
                                                            <el-input style="width: 100px; margin-left: 5px;" v-if="key !== 'stores_exclude'" :name="key" v-model="alertsTableData['budget'].find(x => x.type_name === props.row.type_name).parameters[key]"></el-input>
                                                        </div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                    <div class="col-4">
                                        <h4>Performance alerts</h4>
                                        <el-table
                                            :data="alertsTableData['performance']"
                                            style="width: 100%; margin: 20px 0px;"
                                        >
                                            <el-table-column
                                                prop="type_name"
                                                label="Name"
                                            >
                                                <template slot-scope="scope">
                                                    {{scope.row.type_name | formatVariableName}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-for="col in alertTableHeaders['performance']"
                                                :key="col.prop"
                                                :prop="col.prop"
                                                :label="col.label">
                                                <template slot-scope="scope">
                                                    <el-checkbox :disabled="scope.row[col.prop+'_setting'] === false" v-model="scope.row[col.prop]"></el-checkbox>
                                                </template>
                                            </el-table-column>
                                            <el-table-column type="expand">
                                                <template slot-scope="props">
                                                    <div class="row" v-if="Object.keys(props.row.parameters).length === 0">
                                                        <div class="col-12">
                                                            <span>No parameters</span>
                                                        </div>
                                                    </div>
                                                    <div class="row center-align-vert mb-10" v-else v-for="(value,key) in props.row.parameters" :key=key>
                                                        <div class="col-4">
                                                            <span class="demo-input-label" style="width: 100px;">{{key | formatVariableName}}</span>
                                                        </div>
                                                        <div class="col-8">
                                                            <el-select
                                                                v-model="mutedStores.find(x => x.type_name === props.row.type_name).store_id"
                                                                filterable
                                                                :clearable=true
                                                                multiple
                                                                collapse-tags
                                                                class="ml-5-howrly"
                                                                style="min-width: 150px;"
                                                                placeholder="Exclude stores"
                                                                v-if="(key === 'stores_exclude' &&  mutedStores.find(x => x.type_name === props.row.type_name) !== undefined)"
                                                            >
                                                                <el-option
                                                                    v-for="item in $store.getters['general/getStores']"
                                                                    :key="item.store_id"
                                                                    :label="item.store_name"
                                                                    :value="item.store_id">
                                                                </el-option>
                                                            </el-select>
                                                            <el-input style="width: 100px; margin-left: 5px;" v-if="key !== 'stores_exclude'" :name="key" v-model="alertsTableData['performance'].find(x => x.type_name === props.row.type_name).parameters[key]"></el-input>
                                                        </div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                    <div class="col-4">
                                        <h4>Cost alerts</h4>
                                        <el-table
                                            :data="alertsTableData['cost']"
                                            style="width: 100%; margin: 20px 0px;"
                                            default-expand-all>
                                            <el-table-column
                                                prop="type_name"
                                                label="Name"
                                            >
                                                <template slot-scope="scope">
                                                    {{scope.row.type_name | formatVariableName}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                v-for="col in alertTableHeaders['cost']"
                                                :key="col.prop"
                                                :prop="col.prop"
                                                :label="col.label">
                                                <template slot-scope="scope">
                                                    <el-checkbox :disabled="scope.row[col.prop+'_setting'] === false" v-model="scope.row[col.prop]"></el-checkbox>
                                                </template>
                                            </el-table-column>
                                            <el-table-column type="expand">
                                                <template slot-scope="props">
                                                    <div class="row" v-if="Object.keys(props.row.parameters).length === 0">
                                                        <div class="col-12">
                                                            <span>No parameters</span>
                                                        </div>
                                                    </div>
                                                    <div class="row center-align-vert mb-10" v-else v-for="(value,key) in props.row.parameters" :key=key>
                                                        <div class="col-4">
                                                            <span class="demo-input-label" style="width: 100px;">{{key | formatVariableName}}</span>
                                                        </div>
                                                        <div class="col-8">
                                                            <el-select
                                                                v-model="mutedStores.find(x => x.type_name === props.row.type_name).store_id"
                                                                filterable
                                                                :clearable=true
                                                                multiple
                                                                collapse-tags
                                                                class="ml-5-howrly"
                                                                style="min-width: 150px;"
                                                                placeholder="Exclude stores"
                                                                v-if="(key === 'stores_exclude' &&  mutedStores.find(x => x.type_name === props.row.type_name) !== undefined)"
                                                            >
                                                                <el-option
                                                                    v-for="item in $store.getters['general/getAllStores']"
                                                                    :key="item.store_id"
                                                                    :label="item.store_name"
                                                                    :value="item.store_id">
                                                                </el-option>
                                                            </el-select>
                                                            <el-input style="width: 100px; margin-left: 5px;" v-if="key !== 'stores_exclude'" :name="key" v-model="alertsTableData['cost'].find(x => x.type_name === props.row.type_name).parameters[key]"></el-input>
                                                        </div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="Stores followed" name="Stores followed" v-if="isAdmin">
                                <div class="row">
                                    <div class="col-12">
                                        <el-input
                                            v-model="search"
                                            placeholder="Type to search"
                                            style="width: 200px; margin-left: 10px;"
                                        />
                                    </div>
                                </div>
                                <template>
                                    <el-table
                                        :data="followedStores.filter(data => !search || String(data['Store']).includes(search))"
                                        style="width: 100%; margin: 20px 0px;"
                                        :default-sort = "{prop: 'Store', order: 'ascending'}">>
                                        <el-table-column
                                            label="Store"
                                            prop="Store"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                {{$store.state.general.stores.find(x => x.store_id === scope.row.Store).store_name}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-for="col in Object.values(this.$store.getters['budget/getLevels'])"
                                            :key="col"
                                            :prop="col"
                                            :label="col">
                                            <template slot-scope="scope">
                                                <el-checkbox text-colo="#000000" disabled v-model="scope.row[col]"></el-checkbox>
                                                <el-button class="ml-5-howrly" size="mini" v-if="addUser !== scope.row.Store + '-' + col" type="primary" plain @click="addUser = scope.row.Store + '-' + col" icon="el-icon-plus"></el-button>
                                                <el-select
                                                    v-model="userToFollow"
                                                    filterable
                                                    collapse-tags
                                                    size="mini"
                                                    placeholder="Please select a user"
                                                    v-if="addUser === scope.row.Store + '-' + col">
                                                    <el-option
                                                        v-for="user in $store.getters['general/getUsers']"
                                                        :key="user.user_id"
                                                        :label="user.first_name +' '+ user.last_name"
                                                        :value="user.user_id">
                                                    </el-option>
                                                </el-select>
                                                <el-button class="ml-5-howrly" size="mini" v-if="addUser === scope.row.Store + '-' + col" type="success" plain @click="addUserFollow()" icon="el-icon-check"></el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import vue from 'vue'
import { getHeadersWithAccessToken } from '../../functions.js'
import Avatar from 'vue-avatar'

export default {
    data () {
        return {
            isAdmin: true,
            user: {},
            loaded: false,
            alerts: {},
            activeName: 'Stores',
            tableData: [],
            alertsTableData: { 'budget': [], 'performance': [], 'cost': [] },
            alertTableHeaders: { 'budget': [{ 'prop': 'internal', 'label': 'Internal' }, { 'prop': 'external', 'label': 'External' }], 'performance': [{ 'prop': 'internal', 'label': 'Internal' }, { 'prop': 'external', 'label': 'External' }], 'cost': [{ 'prop': 'internal', 'label': 'Internal' }, { 'prop': 'external', 'label': 'External' }] },
            search: '',
            interestsUpdated: false,
            followedStores: [],
            addUser: false,
            userToFollow: '',
            mutedStores: []
        }
    },
    components: {
        Avatar
    },
    methods: {
        addUserFollow () {
            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user_interests?user_id=' + this.userToFollow, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.interestsUpdated = true
                    // eslint-disable-next-line
                    setTimeout(() => this.interestsUpdated = false, 5000)
                    let userInterest = response.data.data
                    if (Object.keys(userInterest['stores_budget']).includes(this.addUser.split('-')[1])) {
                        userInterest['stores_budget'][this.addUser.split('-')[1]].push(parseInt(this.addUser.split('-')[0]))
                    } else {
                        userInterest['stores_budget'][this.addUser.split('-')[1]] = [parseInt(this.addUser.split('-')[0])]
                    }

                    axios.put(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user_interests?user_id=' + this.userToFollow, userInterest, { headers: getHeadersWithAccessToken() })
                        .then(response => {
                            this.getFollowedStores()
                            this.userToFollow = ''
                            this.addUser = false
                        })
                        .catch(error => {
                            console.log(error)
                        })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        userSelectChange (open) {
            // Everytime the user selects a user and closes the select we fetch the new data for the tabels for the selected user
            if (open === false) {
                this.getTableData()
                this.getAlertTableData()

                // Get the muted stores per message for this user
                axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/user_message_mute?user_id=' + this.user, { headers: getHeadersWithAccessToken() })
                    .then(response => {
                        this.mutedStores = response.data.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        getTableData () {
            // We ge tthe interest, stores and levels and format the data for in the stores interests table
            let tableData = []
            let stores = this.$store.getters['general/getStores'].map(s => s.store_id)
            let levels = this.$store.getters['budget/getLevels']
            this.$store.dispatch('general/getAlertInterests', this.user).then(response => {
                let interests = this.$store.getters['general/getAlertInterests']
                for (let store of stores) {
                    let obj = { 'Store': store }
                    for (let level of Object.values(levels)) {
                        obj[level] = false
                        let levelKey = Object.keys(levels).find(key => levels[key] === level)
                        if (Object.keys(interests).includes('stores_budget')) {
                            if (Object.keys(interests['stores_budget']).includes(levelKey)) {
                                if (interests['stores_budget'][levelKey].includes(store)) {
                                    obj[level] = true
                                }
                            }
                        }
                    }
                    tableData.push(obj)
                }
                this.tableData = tableData
            })
                .catch(error => {
                    console.log(error)
                })
        },
        getAlertTableData () {
            this.$store.dispatch('general/getUserMessages', this.user)
                .then(response => {
                    vue.set(this.alertsTableData, 'budget', [])
                    vue.set(this.alertsTableData, 'performance', [])
                    vue.set(this.alertsTableData, 'cost', [])
                    let interests = this.$store.getters['general/getUserMessages']
                    for (let key of ['budget', 'performance', 'cost']) {
                        let moduleMessages = interests.filter(x => x['module'] === key)
                        for (let obj of moduleMessages) {
                            // Put min and max value inside parameters objects and add store exclude
                            obj['parameters']['max_value'] = obj['max_value']
                            obj['parameters']['min_value'] = obj['min_value']

                            if (this.mutedStores.find(x => x.type_name === obj.type_name) !== undefined) {
                                obj['parameters']['stores_exclude'] = []
                            }

                            delete obj['max_value']
                            delete obj['min_value']

                            let message = {}
                            for (let k of Object.keys(obj)) {
                                message[k] = obj[k]
                            }
                            this.alertsTableData[key].push(message)
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getFollowedStores () {
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/settings/interests/stores_missing', { 'format': 'aod' }, { 'headers': getHeadersWithAccessToken() }).then(response => {
                this.followedStores = []
                for (let store of this.$store.getters['general/getStores']) {
                    let obj = { 'Store': store.store_id }
                    for (let level in this.$store.getters['budget/getLevels']) {
                        obj[this.$store.getters['budget/getLevels'][level]] = false
                    }
                    for (let item of response.data.data) {
                        if (item.stores_followed.includes(store.store_id)) {
                            obj[this.$store.getters['budget/getLevels'][item.lvl]] = true
                        }
                    }
                    this.followedStores.push(obj)
                }
            })
                .catch(error => {
                    console.log(error)
                })
        },
        saveMessages () {
            // For alerts we need to take max and min value out of parameters field
            let data = []
            for (let key of Object.keys(this.alertsTableData)) {
                for (let message of this.alertsTableData[key]) {
                    message['max_value'] = message['parameters']['max_value']
                    message['min_value'] = message['parameters']['min_value']
                    delete message['parameters']['max_value']
                    delete message['parameters']['stores_exclude']
                    delete message['parameters']['min_value']
                    data.push(message)
                }
            }

            axios.put(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/user_message?sort=list', data, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    // Show the notification for 5 seconds
                    this.interestsUpdated = true
                    // eslint-disable-next-line
                    setTimeout(() => this.interestsUpdated = false, 5000)
                    this.getAlertTableData()
                })
                .catch(error => {
                    console.log(error)
                })

            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/user_message_mute?sort=list', this.mutedStores, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    //
                })
                .catch(error => {
                    console.log(error)
                })
        },
        saveInterests () {
            // For saving the interests we first transform both the store interests table to the right format for the API
            // Then we get the object from the server for the current user and change the stores_budget (interests) field with the formatted table data

            // Interests
            let stores = {}
            let levels = this.$store.getters['budget/getLevels']
            for (let level of Object.keys(levels)) {
                stores[level] = []
            }
            for (let item of this.tableData) {
                for (let level of Object.values(levels)) {
                    let levelKey = Object.keys(levels).find(key => levels[key] === level)
                    if (item[level] === true) {
                        stores[levelKey].push(item['Store'])
                    }
                }
            }

            // Now we first get the current user_interest object from the API and replace the two relevant fields
            let userInterest = {}
            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user_interests?user_id=' + this.user, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    // We set the userInterest object and replace the two relevant fields with the data from the table
                    userInterest = response.data.data
                    userInterest['stores_budget'] = stores
                    axios.put(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user_interests?user_id=' + this.user, userInterest, { headers: getHeadersWithAccessToken() })
                        .then(response => {
                            // Show the notification for 5 seconds
                            this.interestsUpdated = true
                            // eslint-disable-next-line
                            setTimeout(() => this.interestsUpdated = false, 5000)
                        })
                        .catch(error => {
                            console.log(error)
                        })
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    created () {
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/secrets', { headers: getHeadersWithAccessToken() })
            .then(response => {
                if (response.data.roles.includes(1)) {
                    this.admin = true
                }
                this.user = response.data.user_id

                // Make sure the needed data is loaded into Vuex and after that set the default selected user and load the tables
                let promiseList = [this.$store.dispatch('budget/getLevels'), this.$store.dispatch('general/getAllStores'), this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getUsers')]
                Promise.all(promiseList).then(response => {
                    // this.user = this.$store.getters['general/getUsers'].find(x => x.user_id === 1).user_id
                    this.loaded = true
                    this.getTableData()
                    this.getAlertTableData()
                    if (this.admin === true) {
                        this.getFollowedStores()
                    }
                })
                    .catch(error => {
                        console.log(error)
                    })

                axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/user_message_mute?user_id=' + this.user, { headers: getHeadersWithAccessToken() })
                    .then(response => {
                        this.mutedStores = response.data.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-interests {
    p {
        margin-bottom: 0px;
    }
    .el-select {
        .el-input__inner {
            width: 220px;
        }
    }
    .el-checkbox__inner {
        height: 21px !important;
        width: 21px !important;
    }
    .el-checkbox__inner::after {
        height: 10.5px;
        left: 7px;
        width: 4.5px;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
        border-color: #333333;
    }
}
</style>
